import styled from 'styled-components';

// Native <ul> list markers (::marker) are NOT reproduced faithfully by html2canvas,
// so the PDF showed tiny inline bullets that did not match the live view (RR-603).
// Rendering the bullet as a real "•" element (not a ::marker / ::before pseudo) makes
// the live view and the PDF capture identical by construction.
export const BulletListContainer = styled.ul`
  list-style: none;
  margin: 8px 0;
  padding-inline-start: 24px;
`;

export const BulletListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const BulletMark = styled.span`
  flex-shrink: 0;
  line-height: 1.5;
`;
